export const ACTIONS = {
  SET_COLOUR: "SET_COLOUR",
};
